// react-router v6's useNavigate returns a different function whenever the location changes,
// it leads to unnecessary re-renderings, as well as the inability to use it in useEffect's dependency array.
// Ref: https://github.com/remix-run/react-router/issues/7634
import { useCallback, useContext } from 'react';
import { UNSAFE_DataRouterContext as DataRouterContext } from 'react-router';

const useNavigate = () => {
  const context = useContext(DataRouterContext);

  if (!context) {
    throw new Error(
      'useNavigate needs to be called in a react-router data router context',
    );
  }

  const { navigate } = context.router;

  return useCallback(
    (...args: Parameters<typeof navigate>) => {
      navigate(...args);
    },
    [navigate],
  );
};

export default useNavigate;

export type NavigateFunction = ReturnType<typeof useNavigate>;
